import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { AuthContext } from "../../context/AuthContext";
import Table from "../../components/Table";
import { ArrowSphereClientColumn } from "../../components/headerContent";
import { useTranslation } from "react-i18next";
import Loader from "../../components/Loader";

export default function ArrowSphereClient() {
    const { apiUrl } = useContext(AuthContext);
    const { t } = useTranslation();

    const getArrowSphereClient = async () => {
        try {
            const res = await axios.get(`${apiUrl}microsoft/arrow/licenses/client`, {
                withCredentials: true,
            });
            return res.data;
        } catch (error) {
        }
    };

    const arrowSphereClient = useQuery({
        queryKey: ["arrowSphereClient"],
        queryFn: getArrowSphereClient,
    });

    if (arrowSphereClient.data && arrowSphereClient.data.message === "Ce client ne possède pas d'id Arrow") {
        return <h1 className="page-title"> Pas de données ArrowSphere disponibles</h1>
    }

    return (
        <>
            {!arrowSphereClient.isLoading ? (
                <div className='cato-content-table mt-1'>
                    {!arrowSphereClient.data.message && arrowSphereClient.data.length > 0 ? (
                        <Table
                            tableData={arrowSphereClient.data}
                            tableColumns={ArrowSphereClientColumn}
                            checkbox={false}
                        />
                    ) : arrowSphereClient.data.message || arrowSphereClient.data.length === 0 ? (
                        <h1 className="page-title">Pas de données ArrowSphere disponibles</h1>
                    ) : (
                        <Loader />
                    )}
                </div>
            ) : (
                <Loader />
            )}
        </>
    );
}